import React, { useMemo } from "react";
import { ThemeProvider, createTheme, responsiveFontSizes, StyledEngineProvider } from "@mui/material";
import { createCompanyTheme } from "../lib/pop_design_system";

const CompanyThemeProvider = ({ mode = "light", children }) => {
  const theme = useMemo(() => {
    let base = createCompanyTheme(mode);
    base = createTheme({
      ...base,
      typography: {
        fontFamily: "inherit",
        fontSize: undefined,
        fontWeightLight: undefined,
        fontWeightRegular: undefined,
        fontWeightMedium: undefined,
        h1: {},
        h2: {},
        h3: {},
        h4: {},
        h5: {},
        h6: {},
        subtitle1: {},
        subtitle2: {},
        body1: {},
        body2: {},
        button: {},
        caption: {},
        overline: {}
      },
      components: {
        ...(base.components || {}),
        MuiButton: {
          ...(base.components?.MuiButton || {}),
          styleOverrides: {
            ...(base.components?.MuiButton?.styleOverrides || {}),
            root: {
              ...(base.components?.MuiButton?.styleOverrides?.root || {}),
              fontSize: "1rem",
              textTransform: "none"
            }
          }
        }
      }
    });
    return responsiveFontSizes(createTheme(base));
  }, [mode]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
};

export default CompanyThemeProvider;
